import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import styles from '../../DeviceLinks.module.css';
import NoDeviceButton from '../NoDeviceButton';
import { QRCodeSVG } from 'qrcode.react';

const QRCode = (props) => {
    return (
        <React.Fragment>
            <Card.Body style={{ padding: '24px 0px 0px' }} className={styles.body}>
                <h4 className={styles.PassportCardHeading}>Scan QR code</h4>
                <p className={styles.PassportCardSubheading}>
                    Point your phone's camera to this QR code and follow the link.
                </p>
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <QRCodeSVG value={props.link} />
                </div>
            </Card.Body>
            {
                <Card.Footer
                    style={{
                        padding: '68px 0px 0px',
                        border: 'none',
                        background: 'none',
                    }}
                    className="text-muted"
                >
                    {!props?.isReauthenticate && (
                        <NoDeviceButton navigate={props.navigate} stopPolling={props.stopPolling} />
                    )}
                </Card.Footer>
            }
        </React.Fragment>
    );
};

QRCode.propTypes = {
    link: PropTypes.string,
    navigate: PropTypes.func,
    stopPolling: PropTypes.func,
    isReauthenticate: PropTypes.bool,
};

export default QRCode;
